var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.disabled ? 'div' : (_vm.isNuxt ? 'nuxt-link' : 'a'),{tag:"a",attrs:{"to":_vm.isNuxt && !_vm.disabled ? _vm._href : null,"href":_vm._href,"title":_vm.title}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }